<script lang="ts">
	import { clickOutside } from '$lib/actions/click-outside';
	import { SearchInput } from '$lib/components';
	import { searchAdults, searchChildren, searchInfants } from '$lib/stores/search.svelte';
	import { text } from '$lib/utils/text';
	import { MinusCircle, PlusCircle } from 'lucide-svelte';

	type Props = {
		error?: string | string[] | undefined;
	};

	let pax = $derived.by(
		() => searchAdults.current + searchChildren.current + searchInfants.current
	);
	let showPassengers = $state(false);
	let { error = undefined }: Props = $props();

	const subAdults = () => {
		if (searchAdults.current > 1) {
			searchAdults.current = searchAdults.current - 1;
		}
	};
	const addAdults = () => {
		if (searchAdults.current < 50) {
			searchAdults.current = searchAdults.current + 1;
		}
	};
	const subChildren = () => {
		if (searchChildren.current > 0) {
			searchChildren.current = searchChildren.current - 1;
		}
	};
	const addChildren = () => {
		if (searchChildren.current < 50) {
			searchChildren.current = searchChildren.current + 1;
		}
	};
	const subInfants = () => {
		if (searchInfants.current > 0) {
			searchInfants.current = searchInfants.current - 1;
		}
	};
	const addInfants = () => {
		if (searchInfants.current < 50) {
			searchInfants.current = searchInfants.current + 1;
		}
	};
</script>

<div use:clickOutside onclickoutside={() => (showPassengers = false)}>
	<SearchInput {error}>
		<button
			type="button"
			aria-labelledby="Passengers"
			aria-haspopup="listbox"
			class="relative w-full text-left top-0 pb-0 -mb-1 focus:outline-none"
			onclick={() => {
				showPassengers = !showPassengers;
			}}
			onkeydown={(e) => {
				if (e.key === 'ArrowDown') {
					showPassengers = true;
				}
				if (e.key === 'Escape') {
					showPassengers = false;
				}
			}}
		>
			<div class="input-label whitespace-nowrap">Passengers</div>
			<div>
				{#if pax}
					{pax}
				{:else}
					<span class="italic text-slate-500 dark:text-slate-400">Select</span>
				{/if}
			</div>
		</button>
		<input type="hidden" name="adults" value={searchAdults.current} />
		<input type="hidden" name="children" value={searchChildren.current} />
		<input type="hidden" name="infants" value={searchInfants.current} />

		{#if showPassengers}
			<div
				class="bg-two rounded-base absolute left-0 top-16 z-10 grid w-[300px] grid-cols-1 gap-2 p-5 shadow-xl"
			>
				<div class="flex items-center justify-between">
					<div>
						<div>
							{searchAdults.current || 'Select'}
							{text.pluralize('adult', searchAdults.current)}
						</div>
						<div class="text-sm text-slate-500">13+ years</div>
					</div>

					<div class="grid grid-cols-2 gap-6 md:gap-3">
						<button
							type="button"
							class="disable-double-tap hover:text-primary text-xl text-slate-400"
							onclick={subAdults}
							onkeydown={(e) => {
								if (e.key === 'Escape') {
									showPassengers = false;
								}
							}}
						>
							<MinusCircle />
						</button>
						<button
							type="button"
							class="disable-double-tap hover:text-primary text-xl text-slate-400"
							onclick={addAdults}
							onkeydown={(e) => {
								if (e.key === 'Escape') {
									showPassengers = false;
								}
							}}
						>
							<PlusCircle />
						</button>
					</div>
				</div>
				<hr class="border-body my-0" />
				<div class="flex items-center justify-between">
					<div>
						<div>
							{searchChildren.current || 'No'}
							{text.pluralize('child', searchChildren.current)}
						</div>
						<div class="text-sm text-slate-500">2-12 years</div>
					</div>
					<div class="grid grid-cols-2 gap-6 md:gap-3">
						<button
							type="button"
							class="disable-double-tap hover:text-primary text-xl text-slate-400"
							onclick={subChildren}
							onkeydown={(e) => {
								if (e.key === 'Escape') {
									showPassengers = false;
								}
							}}
						>
							<MinusCircle />
						</button>
						<button
							type="button"
							class="disable-double-tap hover:text-primary text-xl text-slate-400"
							onclick={addChildren}
							onkeydown={(e) => {
								if (e.key === 'Escape') {
									showPassengers = false;
								}
							}}
						>
							<PlusCircle />
						</button>
					</div>
				</div>
				<hr class="border-body my-0" />
				<div class="flex items-center justify-between">
					<div>
						<div>
							{searchInfants.current || 'No'}
							{text.pluralize('infant', searchInfants.current)}
						</div>
						<div class="text-sm text-slate-500">0-1 years</div>
					</div>
					<div class="grid grid-cols-2 gap-6 md:gap-3">
						<button
							type="button"
							class="disable-double-tap hover:text-primary text-xl text-slate-400"
							onclick={subInfants}
							onkeydown={(e) => {
								if (e.key === 'Escape') {
									showPassengers = false;
								}
							}}
						>
							<MinusCircle />
						</button>
						<button
							type="button"
							class="disable-double-tap hover:text-primary text-xl text-slate-400"
							onclick={addInfants}
							onkeydown={(e) => {
								if (e.key === 'Escape') {
									showPassengers = false;
								}
							}}
						>
							<PlusCircle />
						</button>
					</div>
				</div>
			</div>
		{/if}
	</SearchInput>
</div>
